import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useMemo,
} from "react";
import { StationFormData } from "../schemas/station";

interface CopyContextType {
  copiedStation: StationFormData;
  setCopiedStation: (station: StationFormData) => void;
}

const initialState: StationFormData = {
  name: "",
  connectorId: "",
  paymentId: "",
  currency: "USD" as const,
  pricePerKWh: "",
};

const CopyContext = createContext<CopyContextType>({
  copiedStation: initialState,
  setCopiedStation: () => {},
});

interface CopyProviderProps {
  children: ReactNode;
}

export const CopyProvider: React.FC<CopyProviderProps> = ({ children }) => {
  const [copiedStation, setCopiedStation] =
    useState<StationFormData>(initialState);

  const contextValue = useMemo(
    () => ({
      copiedStation,
      setCopiedStation,
    }),
    [copiedStation]
  );

  return (
    <CopyContext.Provider value={contextValue}>{children}</CopyContext.Provider>
  );
};

export const useCopyContext = (): CopyContextType => {
  const context = useContext(CopyContext);
  if (!context) {
    throw new Error("useCopyContext must be used within a CopyProvider");
  }
  return context;
};
